import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AnamneseConfiguracaoEditarComponent } from './anamnese-configuracao-editar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: ':id', component: AnamneseConfiguracaoEditarComponent}
  ])],
  exports: [RouterModule]
})
export class AnamneseConfiguracaoEditarRoutingModule { }
